// Dependencies
import styled, { css } from 'styled-components';

// Types
import { sizeTypography, variantTypography, colorTypography } from './types';

interface ContainerProps {
  variant: variantTypography;
  size: sizeTypography;
  colorText: colorTypography;
}

export const Container = styled.p<ContainerProps>`
  font-family: 'Poppins', sans-serif;
  color: ${(props) =>
    props.theme.colors[props.colorText as keyof typeof props.theme.colors]};
  ${({ variant, theme }) =>
    ({
      regular: css`
        font-weight: ${theme.fontWeight.regular};
      `,
      medium: css`
        font-weight: ${theme.fontWeight.medium};
      `,
      semiBold: css`
        font-weight: ${theme.fontWeight.semiBold};
      `,
    })[variant]}

  ${({ size, theme }) =>
    ({
      XL: css`
        font-size: ${theme.fontSize.XL};
      `,
      L: css`
        font-size: ${theme.fontSize.L};
      `,
      M: css`
        font-size: ${theme.fontSize.M};
      `,
      S: css`
        font-size: ${theme.fontSize.S};
      `,
      XS: css`
        font-size: ${theme.fontSize.XS};
      `,
      XXS: css`
        font-size: ${theme.fontSize.XXS};
      `,
      XXXS: css`
        font-size: ${theme.fontSize.XXXS};
      `,
    })[size]}
`;
